import * as types from '../mutation-types';

export default {
	namespaced: true,
	state: {
        entities: [],
        entitiesBrief: [],
        entitiesFiltered:[],
        allEntities: []
	},

	actions: {
        fetchByFilter({ commit }, { type, name, workloadId, specialtyId, regionIds, page, perPage, nonDeleted, OrderByWorkLoad, OrderByName }){
            var urlSearchParams = new URLSearchParams();
            var params = { type, name, workloadId, specialtyId, page, perPage, nonDeleted, OrderByWorkLoad, OrderByName }

            Object.keys(params).forEach(param => {
                if (params[param] !== null && params[param] !== undefined) urlSearchParams.append(param, params[param])
            });
            regionIds.forEach(id => {
                urlSearchParams.append('regionIds', id)
            })
            urlSearchParams.append('includeContactInfo', true);
            urlSearchParams.append('includeAddresses', true);
            
            return window.axios.get('/entities', {
                params: urlSearchParams
            })
            .then((response) => {
                commit(types.STORE_ENTITIES, response.data);
                return {
                    data: response.data,
                    total: parseInt(response.headers['x-pagination-total-count'])
                };
            })
        },

        fetchAllBrief({ commit }, { type, regionId }) {
            return window.axios.get('/entities/all/brief', { params: { type, regionId } }).then((response) => {
                commit(types.STORE_ENTITIES_BRIEF, response.data);
                    return {
                        data: response.data,
                        total: parseInt(response.headers['x-pagination-total-count'])
                }
            })
        },
        
        // visited doctor
        fetchVisitedDocotors({ commit }){
            return window.axios.get('/entities', {
                params:{
                    type: 1,
                    WithVisitsCount: true,
                    perPage: 50,
                    nonDeleted: true,
                }
            }).then(response => {
                return response.data;
            })
        },

        fetchVisitedDoctorsByFilter({ commit }, { name, workloadId, specialtyId, regionIds, withVisitsCountFrom, WithVisitsCountTo, page, perPage, IncludeAddresses, bestTimeToVisit, openingTime, closingTime, residentDoctorNames, EmployeeId }){
            var urlSearchParams = new URLSearchParams();
            var params = { name, workloadId, specialtyId, withVisitsCountFrom, WithVisitsCountTo, page, perPage, IncludeAddresses, bestTimeToVisit, openingTime, closingTime, residentDoctorNames, EmployeeId }

            Object.keys(params).forEach(param => {
                if (params[param] !== null && params[param] !== undefined) urlSearchParams.append(param, params[param])
            });
            regionIds.forEach(id => {
                urlSearchParams.append('regionIds', id)
            })
            urlSearchParams.append('type', 1);
            urlSearchParams.append('nonDeleted', true);
            urlSearchParams.append('WithVisitsCount', true);
            
            return window.axios.get('/entities', {
                params: urlSearchParams
            })
            .then((response) => {
                return {
                    data: response.data,
                    total: parseInt(response.headers['x-pagination-total-count'])
                }
            })
        },

        create({ commit }, { data }){
            return window.axios.post('/entities', data);
        },
        
        getById({ commit }, { id }) {
            return window.axios.get(`/entities/${id}`).then(({ data }) => {
                return data
            })
        },
        update({ commit }, { id, data }){
            return window.axios.put(`/entities/${id}`, data);
        },

        delete({ commit }, { id }){
            return window.axios.delete(`/entities/${id}`);
        },

        clearEntitiesBrief({ commit }){
            commit(types.CLEAR_ENTITIES);
        },
	},

	mutations: {
		[types.STORE_ENTITIES](state, entities){
            state.entities = entities;
        },
		[types.STORE_ENTITIES_BRIEF](state, entitiesBrief){
            state.entitiesBrief = entitiesBrief;
        },
        [types.STORE_ENTITIES_ALL](state, allEntities) {
            state.allEntities = allEntities
        },
        [types.CLEAR_ENTITIES](state, entitiesBrief) {
            state.entitiesBrief = []
        }
	},

	getters:{
		getEntityById: state => id => state.entities.find(c => c.id === id),
        getEntityByName: state => name => state.entities.find(c => c.id === name),
        getCustomerById: state => id => state.allEntities.find(c => c.id === id)
	}
}